var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"title":_vm.title,"static":"","size":_vm.size,"hide-footer":""},on:{"close":function($event){$event.preventDefault();return _vm.onClosing('cancel')}}},[_c('div',{ref:"modal-content"})])}
var staticRenderFns = []

export { render, staticRenderFns }